export const SIDEBAR_COORDINATES_KEY = 'MO:floating-sidebar-coordinates';
export const SIDEBAR_PLACEMENT_KEY = 'MO:floating-sidebar-placement';
export const DRAG_AND_DROP_TOOLTIP = 'MO:drag-and-drop-tooltip';
export const COLLABORATION_SIDEBAR_HIDDEN = 'MO:collaboration-sidebar-hidden';
export const ONBOARDING_HIDDEN_FOR_SELENIUM = 'selenium.disable.onboarding_tours';